import InputFiles from "@/components/Forms/Input/input-files.vue";
import { mapGetters } from "vuex";
import { showSuccessSnackBar } from "@/utils/SnackBartHelper"
import Rules from "@/utils/Rules";
import cloneDeep from 'lodash/cloneDeep';
import UtilsProjects from "@/pages/Projects/Utils/Utils.js";
import MaterialsService from "@/services/firebase/Materials/MaterialsService";
import MaterialList from "./MaterialList/MaterialList.vue"
import NextStepProject from '@/components/Projects/NextStepProject.vue';
import Utils from '@/scripts/Utils';
import NotificationsService from "../../../services/server/NotificationsService";
import ProjectsService from "../../../services/server/ProjectsService";
import AverageNextStep from '../../AverageNextStep/AverageNextStep.vue';

export default {
    name: UtilsProjects.STEPS.MATERIALS,
    components: {
        NextStepProject,
        InputFiles,
        MaterialList,
        AverageNextStep
    },
    props: {
        openModal: {
            type: Boolean,
            default: false,
          },
          idProject: {
            type: String,
            default: null,
          },
          idMaterials: {
            type: String,
            default: null,
          },
          closeFunc: {
            type: Function,
            default: () => {},
          },
          currentStep: {
            type: String,
            default: null,
          }
    },
    data: () => ({
      is_loading: false,
      materials: {},
      enableNextStepButton: false,
      buttonMessage: "Habilitar Waterfix",
      confirmReceivingModal: false,
      project: null,
      mapperMovementType: {
          delivery: "Envio",
          receiving: "Recebimento",
          others: "Outros",
      },
      showAverageNextStep: false,
      nextStepVariable: "entrega",
    }),
    computed: {
        ...mapGetters(["getCurrentUserRank"]),
        isFranchisee() {
          return this.getCurrentUserRank === "Franqueado";
        },
        rulesRequired() {
          return Rules.required();
      },
    },
    methods: {
      formatDateTime(date) {
        if (date['seconds'] !== undefined && date['nanoseconds'] !== undefined) {
          return Utils.formatDateDayJs(date['seconds'] * 1000 + date['nanoseconds'] / 1e6, 'DD/MM/YYYY [às] HH:mm');
        } else {
          return Utils.formatDateDayJs(new Date(date), 'DD/MM/YYYY [às] HH:mm');
        }
      },
      verifyMovementsOnMount() {
        const hasReceivingMovement = this.materials.movements.some(
          movement => movement.movementType === 'receiving'
        );
        this.enableNextStepButton = hasReceivingMovement && this.currentStep === UtilsProjects.STEPS.MATERIALS;

        if (this.currentStep === UtilsProjects.STEPS.INSTALLATION) {
          this.buttonMessage = `Waterfix habilitado em: ${this.formatDateTime(this.materials.waterfixRequestDate)}`
        }
      },
      openConfirmReceivingModal() {
        this.confirmReceivingModal = true;
      },
      async activateWaterFixStep() {
        this.is_loading = true;
        await MaterialsService.updateMaterials(this.idMaterials, {waterfixRequestDate: new Date()})
        await UtilsProjects.updateProjectSteps(this.idProject, UtilsProjects.STEPS.INSTALLATION, true);
        this.enableNextStepButton = false;
        showSuccessSnackBar('Waterfix habilitado com sucesso!');
        await UtilsProjects.createSuccessLog(this.idProject, UtilsProjects.STEPS.INSTALLATION, 'Waterfix Habilitado', this.currentStep);
        this.is_loading = false;
        await this.waitForAverageNextStep()
        this.closeMaterialsModal();
      },
      async addMovement(movement, index) {
        this.is_loading = true;
          let messageList = [];

        if (index < 0) {
          this.materials.movements.unshift(movement)
        } else {
          this.$set(this.materials.movements, index, movement);
        }

        const [status, receivedMovement] = await MaterialsService.saveMovement(this.idMaterials, movement, movement.id_doc ? movement.id_doc : null);
        
        if (status) {
          this.$set(this.materials.movements, index < 0 ? 0 : index, receivedMovement);
          if (index < 0) {
            await UtilsProjects.createInfoLog(this.idProject, UtilsProjects.STEPS.MATERIALS, "Nova Movimentação", this.currentStep)
          } else {
            await UtilsProjects.createInfoLog(this.idProject, UtilsProjects.STEPS.MATERIALS, "Movimentação Editada", this.currentStep)
          }
          showSuccessSnackBar("Movimentação salva com sucesso!")
        }

        if (this.isFranchisee) {
            /* Notificação no sino pro admin */
        } else {
            let messageBody =
                movement.movementType === 'delivery' ? `Site de rastreio: *${movement.carrierSite}* Código de rastreio: *${movement.trackingCode}*, verifique a aba de *ENTREGA* no seu projeto para mais detalhes!`
                :
                ``
            const data = UtilsProjects.buildFranchiseeNotificationData(this.project,
                `Foi criado uma movimentação de entrega do tipo: *${this.mapperMovementType[movement.movementType]}* ${messageBody}`);
            messageList.push(data)
            if (this.project.configs?.wpp_notification ?? true) {
                await NotificationsService.bootProjectNotification(messageList)
            }
        }

        this.is_loading = false
      },
      async removeMovement(movement, index) {
            await MaterialsService.removeMovement(this.idMaterials, movement.id_doc)
            this.materials.movements = this.materials.movements.filter((_, i) => i !== index)
            showSuccessSnackBar("Movimentação deletada com sucesso!");
            await UtilsProjects.createInfoLog(this.idProject, UtilsProjects.STEPS.MATERIALS, "Movimentação Deletada", this.currentStep)
      },
      openMovement() {
            this.$refs.movement.openDialog();
      },
      closeMovement() {
            this.$refs.movement.closeDialog();
      },
      async waitForAverageNextStep() {
        return new Promise(resolve => {
          this.showAverageNextStep = true;
      
          const modal = this.$refs.averageModal;
      
          const handler = () => {
            modal.$off('closed', handler);
            resolve();
          };
      
          modal.$on('closed', handler);
        });
      },
      async getDataFromDB() {
        const [status, material] = await MaterialsService.getMaterialsById(this.idMaterials);
        
        this.materials = cloneDeep(material);
        this.initialMaterials = cloneDeep(material);
      },
      closeMaterialsModal() {
          this.closeFunc(UtilsProjects.STEPS.MATERIALS)
      },
    },
    watch: {
      'materials.movements': {
        handler(newMovements) {
          this.enableNextStepButton = newMovements.some(movement => movement.movementType === 'receiving');
        },
        deep: true
      }
    },
    async created() {
      this.is_loading = true;
      await this.getDataFromDB();
      this.verifyMovementsOnMount();
      const [status, project] = await ProjectsService.getProjectById(this.idProject);
      this.project = project;
      this.is_loading = false;
    }
}